import { render, staticRenderFns } from "./preSale-order-detail.vue?vue&type=template&id=96e2c962&scoped=true"
import script from "./preSale-order-detail.vue?vue&type=script&lang=js"
export * from "./preSale-order-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e2c962",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96e2c962')) {
      api.createRecord('96e2c962', component.options)
    } else {
      api.reload('96e2c962', component.options)
    }
    module.hot.accept("./preSale-order-detail.vue?vue&type=template&id=96e2c962&scoped=true", function () {
      api.rerender('96e2c962', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/preSale-management/preSale-order/preSale-order-detail.vue"
export default component.exports